var AlligatorView, CurrentOrderView, EmailFormBaseView, EmailFormCheckboxInputView, EmailFormDropdownInputView, EmailFormEmailInputView, EmailFormFileInputView, EmailFormIntlDateInputView, EmailFormIntlDateTimeInputView, EmailFormIntlMainView, EmailFormIntlPhoneChannelView, EmailFormNumberInputView, EmailFormPhoneNumberInputView, EmailFormRecaptchaView, EmailFormTextLineInputView, EmailFormTextParagraphInputView, EmailFormTextParagraphView, EmailFormUserNameInputView, SharedFooterView, SupportFlexibleEmailFormObjectsTemplate, SupportFlexibleStepThreeTemplate, SupportPhoneContactChannelTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormTextParagraphInputView = require("../common/text_paragraph_input_view");

EmailFormTextParagraphView = require("../common/text_paragraph_view");

EmailFormTextLineInputView = require("../../common/views/text_line_input_view");

EmailFormFileInputView = require("../common/file_input_view");

EmailFormNumberInputView = require("../common/number_input_view");

EmailFormEmailInputView = require("../../common/views/email_input_view");

EmailFormIntlDateTimeInputView = require("./date_time_input");

EmailFormBaseView = require("../base_view");

EmailFormIntlPhoneChannelView = require("./phone_channel_view");

CurrentOrderView = require("../../order_related/current_order_view");

SharedFooterView = require("../../../../../shared/frontend/views/footer/INTL/main_view");

EmailFormIntlDateInputView = require("./date_input_view");

EmailFormDropdownInputView = require("../common/dropdown_input_view");

EmailFormCheckboxInputView = require("../common/checkbox_input_view");

EmailFormUserNameInputView = require("./user_name_input_view");

AlligatorView = require("../../../../../shared/frontend/views/alligator_view");

EmailFormRecaptchaView = require("../common/recaptcha_view");

SupportFlexibleStepThreeTemplate = require('../../../../flexible_step_three.html.mustache');

SupportFlexibleEmailFormObjectsTemplate = require('../../../../flexible_email_form_objects.html.mustache');

SupportPhoneContactChannelTemplate = require('../../../../phone_channel_footer.html.mustache');

EmailFormIntlMainView = (function(superClass) {
  extend(EmailFormIntlMainView, superClass);

  function EmailFormIntlMainView() {
    return EmailFormIntlMainView.__super__.constructor.apply(this, arguments);
  }

  EmailFormIntlMainView.prototype.events = {
    'click .submit-button': 'onSubmitClick'
  };

  EmailFormIntlMainView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    EmailFormBaseView.prototype.initialize.apply(this, arguments);
    this.footerContainer = $("#footer-content");
    this.template = SupportFlexibleStepThreeTemplate;
    this.model = options.emailFormModel;
    this.inputObjects = this.model.getEmailFormInputObjects();
    this.emailFormViewFooter = new SharedFooterView({
      template: SupportPhoneContactChannelTemplate,
      emailUs: this.emailUsCallback,
      model: this.model
    });
    return this.currentOrderView = new CurrentOrderView({
      hideSelfServiceActions: true,
      hideExternalDealNotes: true,
      showV2View: false
    });
  };

  EmailFormIntlMainView.prototype.render = function() {
    AlligatorView.hideWidgets();
    if (this.isPhonePreferredChannel()) {
      return this.contactByPhone();
    } else {
      return this.contactByEmail();
    }
  };

  EmailFormIntlMainView.prototype.isPhonePreferredChannel = function() {
    return this.model.isMethodOfContactByPhone() || this.model.isMethodOfContactByPhoneWithEmail();
  };

  EmailFormIntlMainView.prototype.contactByEmail = function() {
    this.hideComponents();
    this.renderFlexStepThree();
    this.renderInputViews(this.inputObjects, "#componentList");
    if (evaluate(Groupon.Support.ContentModel.isRefundEligible) && Groupon.Support.currentOrder) {
      this.renderCurrentOrder();
    }
    this.renderStepActions();
    return this.validateEmailForm();
  };

  EmailFormIntlMainView.prototype.renderFlexStepThree = function() {
    return this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
  };

  EmailFormIntlMainView.prototype.contactByPhone = function() {
    this.hideComponents();
    this.$el.html(toHtml(this.template, {}, this.I18nScope));
    this.renderPhoneChannelView();
    this.renderStepActions();
    if (this.isPhonePreferredChannel()) {
      this.renderEmailUsFooter();
    }
    return this.hideSubmitButton();
  };

  EmailFormIntlMainView.prototype.emailUsCallback = function() {
    return this.contactByEmail();
  };

  EmailFormIntlMainView.prototype.populateRefundParams = function(currentOrder, orderDetails) {
    var base, ref, ref1;
    currentOrder.formattedTotalPrice = orderDetails.formattedTotalPrice;
    if ((((ref = currentOrder.groupons) != null ? ref[0] : void 0) != null) && (((ref1 = orderDetails.groupons) != null ? ref1[0] : void 0) != null)) {
      return (base = currentOrder.groupons[0]).redemptionCode != null ? base.redemptionCode : base.redemptionCode = orderDetails.groupons[0].redemptionCode;
    }
  };

  EmailFormIntlMainView.prototype.renderCurrentOrder = function() {
    var _successCallback, currentOrder, params;
    currentOrder = Groupon.Support.currentOrder;
    if (!currentOrder.formattedTotalPrice) {
      params = {
        order: currentOrder,
        forceFetchOrderDetails: true,
        isRefundEligible: true
      };
      _successCallback = (function(_this) {
        return function(orderDetails) {
          if (orderDetails) {
            return _this.populateRefundParams(currentOrder, orderDetails);
          }
        };
      })(this);
      Groupon.Support.OrderModel.getOrderDetails(params, _successCallback, function() {});
    }
    this.currentOrderView.$el.addClass('step-three-order-view');
    this.currentOrderView.render();
    return this.$el.find('.step-three-voucher').append(this.currentOrderView.el);
  };

  EmailFormIntlMainView.prototype.renderPhoneChannelView = function() {
    this.phoneChannelView = new EmailFormIntlPhoneChannelView;
    this.phoneChannelView.render();
    return this.$el.append(this.phoneChannelView.el);
  };

  EmailFormIntlMainView.prototype.removePhoneChannelView = function() {
    if (this.phoneChannelView != null) {
      return this.phoneChannelView.remove();
    }
  };

  EmailFormIntlMainView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      isFlexibleStepThree: this.model.isFlexibleStepThree,
      template: SupportFlexibleEmailFormObjectsTemplate
    };
    obj.counter = this.getEmailFormObjectCount(obj.type);
    switch (obj.type) {
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'email_address':
        return new EmailFormEmailInputView(options);
      case 'number':
        return new EmailFormNumberInputView(options);
      case 'text_field_paragraph':
        return new EmailFormTextParagraphInputView(options);
      case 'text_paragraph':
        return new EmailFormTextParagraphView(options);
      case 'text_field_line':
        return new EmailFormTextLineInputView(options);
      case 'attachment':
        return new EmailFormFileInputView(options);
      case 'calendar_date':
        return new EmailFormIntlDateInputView(options);
      case 'calendar_with_hour_slot':
        return new EmailFormIntlDateTimeInputView(options);
      case 'dropdown':
        return new EmailFormDropdownInputView(options);
      case 'checkbox':
        return new EmailFormCheckboxInputView(options);
      case 'user_name':
        return new EmailFormUserNameInputView(options);
      case 'recaptcha':
        return new EmailFormRecaptchaView(options);
    }
  };

  EmailFormIntlMainView.prototype.getEmailFormObjectCount = function(objectType) {
    if (this.model.emailFormObjectsCount[objectType] != null) {
      return ++this.model.emailFormObjectsCount[objectType];
    }
  };

  EmailFormIntlMainView.prototype.renderEmailUsFooter = function() {
    if (this.emailFormViewFooter) {
      this.emailFormViewFooter.render();
      return this.footerContainer.html(this.emailFormViewFooter.el);
    }
  };

  EmailFormIntlMainView.prototype.hideSubmitButton = function() {
    return this.$el.find(".submit-button").hide();
  };

  EmailFormIntlMainView.prototype.showSubmitButton = function() {
    return this.$el.find(".submit-button").show();
  };

  EmailFormIntlMainView.prototype.toHash = function() {
    var ref, ref1;
    return {
      reason: this.getIssueReason(),
      is_order: Groupon.Support.currentOrder != null,
      show_reason: !this.model.isDummyCategory,
      email_channel: true,
      merchant_name: getDealMerchantName(),
      faqInsteadHelpWizard: window.faqInsteadHelpWizard,
      escalate_to_merchant: Groupon.Support.ContentModel.escalateToMerchant,
      is_refund_eligible: Groupon.Support.ContentModel.isRefundEligible,
      deal_option_title: (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.dealOption) != null ? ref1.title : void 0 : void 0
    };
  };

  EmailFormIntlMainView.prototype.getChatParams = function() {
    var params;
    return params = {
      issue: this.getIssueReason()
    };
  };

  EmailFormIntlMainView.prototype.getIssueReason = function() {
    return this.model.reasonText;
  };

  return EmailFormIntlMainView;

})(EmailFormBaseView);

module.exports = EmailFormIntlMainView;

//# sourceMappingURL=data:application/json;base64,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
